// extracted by mini-css-extract-plugin
export default {"button":"dk-z","reviewSort":"ek-z"};